import { NgModule } from '@angular/core';
import { AdminStates } from '@client/app/feature-modules/admin/states/admin.state';
import {
    AdminApiTokensStates,
} from '@client/app/feature-modules/admin/modules/admin-api-tokens/states/admin-api-tokens.state';
import { AdminUsersStates } from '@client/app/feature-modules/admin/modules/admin-users/states/admin-users.state';
import {
    AdminPerformanceProfilesStates,
} from '@client/app/feature-modules/admin/modules/admin-performance-profiles/states/admin-performance-profiles.state';
import { AdminLabelsStates } from '@client/app/feature-modules/admin/modules/admin-labels/states/admin-labels.state';
import { AdminAuditLogStates } from './modules/admin-audit-log/states/admin-audit-log.state';
import { AdminScanExclusionsStates } from '@client/app/feature-modules/admin/modules/admin-scan-exclusions/states/admin-scan-exclusions.state';
import { AdminDashboardStates } from '@client/app/feature-modules/admin/modules/admin-dashboard/states/admin-dashboard.states';
import { AdminJiraConnectorStates } from '@client/app/feature-modules/admin/modules/admin-jira-connector/states/admin-jira-connector.state';
import { SharedModule } from '@client/app/feature-modules/shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
    imports: [
        SharedModule,
        UIRouterModule.forChild({
            states: [
                AdminStates,
                AdminApiTokensStates,
                AdminUsersStates,
                AdminPerformanceProfilesStates,
                AdminLabelsStates,
                AdminAuditLogStates,
                AdminScanExclusionsStates,
                AdminDashboardStates,
                AdminJiraConnectorStates,
            ].flat(),
        }),
    ],
    providers: [],
})
export class AdminModule {}
